import { useState } from 'react';
import { useQuery as useReactQuery, useQueryClient } from 'react-query';
import useClient from '@pkg/client/useClient';
import GraphQLError from '@pkg/client/utils/GraphQLError';

/**
 * @param {object} params
 * @param {any[]} [params.query]
 *
 * @return {object}
 */
export default function useQuery({ query, onError, ...options }) {
  const [isAuthError, setAuthError] = useState(false);
  const client = useClient();

  function handleErrors(error) {
    if (error instanceof GraphQLError && error.isAuthorizationError()) {
      setAuthError(true);
    }

    if (onError) {
      onError(error);
    }
  }

  async function fetcher() {
    const [mutation, variables] = query;
    const response = await client.graphql({ query: mutation, variables });
    return response.data;
  }

  const defaultOptions = {
    refetchOnWindowFocus: false,
  };

  const result = useReactQuery({
    queryKey: options.queryKey ?? query,
    queryFn: fetcher,
    onError: handleErrors,
    ...defaultOptions,
    ...options,
  });

  const queryClient = useQueryClient();
  const invalidate = () => {
    queryClient.invalidateQueries(options.queryKey ?? query);
  };

  return {
    invalidate,
    isAuthError,
    ...result,
  };
}
